var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
export var typesColors = {
    success: {
        backgroundColor: colors.successBright,
        color: colors.black
    },
    warn: {
        backgroundColor: colors.warningBright,
        color: colors.black
    },
    error: {
        backgroundColor: colors.errorDeep,
        color: colors.white
    },
    dark: {
        backgroundColor: colors.black,
        color: colors.white
    },
    "default": {
        backgroundColor: colors.neutralBrightest,
        color: colors.black
    }
};
var bannerStylesByType = function (type) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n"], ["\n  background-color: ", ";\n  color: ", ";\n"])), typesColors[type].backgroundColor, typesColors[type].color); };
export var AlertBannerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #e6e6eb;\n  display: ", ";\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 0.75rem;\n  padding: 1rem;\n\n  ", ";\n"], ["\n  background-color: #e6e6eb;\n  display: ", ";\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 0.75rem;\n  padding: 1rem;\n\n  ", ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'flex' : 'none');
}, function (_a) {
    var alertBannerType = _a.alertBannerType;
    return bannerStylesByType(alertBannerType);
});
var templateObject_1, templateObject_2;
